import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "m-auto w-full",
  style: {"background-color":"#ffffff","background-size":"100%","height":"150px","position":"relative"}
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { style: {"position":"absolute","left":"-10px","top":"10px"} }
const _hoisted_4 = {
  key: 0,
  class: "label new"
}
const _hoisted_5 = {
  key: 1,
  class: "label sale"
}
const _hoisted_6 = { class: "h-1/5 flex items-end justify-center text-center" }
const _hoisted_7 = { class: "font-semibold mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([[_ctx.item.active ? 'material-border-selected' : '' ], "material-select material-border my-4 cursor-pointer pt-4 pb-2 px-4"]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('drawerCardEmit', _ctx.item, this.$parent.$attrs.id)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: _ctx.item.thumbnail,
        class: _normalizeClass(["card-thumbnail", {'object-contain': _ctx.item.tile}])
      }, null, 10, _hoisted_2),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.item.newitem)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('Novo')), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.item.discount)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('Akcija')), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.item.title), 1)
    ])
  ], 2))
}